import React, { Component } from 'react';
import $ from 'jquery';
import { findDOMNode } from 'react-dom';

export default class Octagon extends Component {

toggle = () => {
    let toggle = findDOMNode(this.refs.toggle);
    $(toggle).toggle();
}

	render() {
		return (
			<div>
                <iframe id="video" ref="toggle" src="https://www.youtube.com/embed/jNgmxKRKNaU" 
                title="The Octagon"></iframe>
				<button
					type="button"
					className="btn octagon"
					onClick={this.toggle}
				>
					The Octagon
				</button>
			</div>
		);
	}
}
